export interface Product {
  id: number;
  name: string;
  pricingProductId: number;
  amount: number;
  currencyCode: string;
}
